import { render, staticRenderFns } from "./RepositoryTokenList.vue?vue&type=template&id=2662b1a8&"
import script from "./RepositoryTokenList.vue?vue&type=script&lang=js&"
export * from "./RepositoryTokenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports